import React, { useEffect, useState } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import brLocale from 'date-fns/locale/pt-BR';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Button, Stack, TextField } from '@mui/material';
import Typography from "@material-ui/core/Typography";
import api from '../../services/api';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import './button.css';
import { i18n } from '../../translate/i18n';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
            display: false,
        },
        title: {
            display: true,
            text: i18n.t("dashboard.charts.date.label"),
            position: 'left',
        },
        datalabels: {
            display: true,
            anchor: 'start',
            offset: -30,
            align: "start",
            color: "#fff",
            textStrokeColor: "#000",
            textStrokeWidth: 2,
            font: {
                size: 20,
                weight: "bold"
            },
        }
    },
};

export const ChartsDate = () => {
    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());
    const [ticketsData, setTicketsData] = useState({ data: [], count: 0 });

    const companyId = localStorage.getItem("companyId");

    useEffect(() => {
        let isMounted = true;
        const token = localStorage.getItem("token");

        if (!token) return;

        const getData = async () => {
            try {
                const { data } = await api.get(`/dashboard/ticketsDay?initialDate=${format(initialDate, 'yyyy-MM-dd')}&finalDate=${format(finalDate, 'yyyy-MM-dd')}&companyId=${companyId}`);
                if (isMounted) setTicketsData(data);
            } catch (error) {
                if (isMounted) toast.error(i18n.t("dashboard.toasts.dateChartError"));
            }
        };

        getData();

        return () => {
            isMounted = false;
        };
    }, [initialDate, finalDate, companyId]);

    const dataCharts = {
        labels: ticketsData?.data?.length > 0 ? ticketsData.data.map((item) =>
            item.hasOwnProperty('horario') ? `Das ${item.horario}:00 as ${item.horario}:59` : item.data
        ) : [],
        datasets: [
            {
                data: ticketsData?.data?.length > 0 ? ticketsData.data.map((item) => item.total) : [],
                backgroundColor: '#2DDD7F',
            },
        ],
    };

    return (
        <>
            <Typography component="h2" variant="h6" color="primary" gutterBottom>
                {i18n.t("dashboard.charts.date.title")} ({ticketsData?.count})
            </Typography>

            <Stack direction={'row'} spacing={2} alignItems={'center'} sx={{ my: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
                    <DatePicker
                        value={initialDate}
                        onChange={(newValue) => setInitialDate(newValue)}
                        label={i18n.t("dashboard.charts.date.start")}
                        slotProps={{ textField: { fullWidth: true, sx: { width: '20ch' } } }}
                    />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
                    <DatePicker
                        value={finalDate}
                        onChange={(newValue) => setFinalDate(newValue)}
                        label={i18n.t("dashboard.charts.date.end")}
                        slotProps={{ textField: { fullWidth: true, sx: { width: '20ch' } } }}
                    />
                </LocalizationProvider>

                <Button className="buttonHover" onClick={() => {}} variant='contained'>
                    {i18n.t("dashboard.charts.date.filter")}
                </Button>
            </Stack>

            <Bar options={options} data={dataCharts} style={{ maxWidth: '100%', maxHeight: '280px' }} />
        </>
    );
};